// SPDX-License-Identifier: AGPL-3.0-or-later

import {getElectronAPI, isLinuxWaylandDesktopSession} from '@app/features/ui/utils/NativeUtils';

export type DisplayShareEnvironment = 'web' | 'desktop-custom' | 'desktop-wayland';

export function resolveDisplayShareEnvironment(
	hasElectronApi: boolean,
	isLinuxWaylandDesktop: boolean,
): DisplayShareEnvironment {
	if (!hasElectronApi) {
		return 'web';
	}

	return isLinuxWaylandDesktop ? 'desktop-wayland' : 'desktop-custom';
}

export async function getDisplayShareEnvironment(): Promise<DisplayShareEnvironment> {
	const electronApi = getElectronAPI();
	if (!electronApi) {
		return 'web';
	}

	const isLinuxWaylandDesktop = electronApi.platform === 'linux' && (await isLinuxWaylandDesktopSession());
	return resolveDisplayShareEnvironment(true, isLinuxWaylandDesktop);
}

export function usesNativeDisplaySharePicker(environment: DisplayShareEnvironment): boolean {
	return environment !== 'desktop-custom';
}

export function usesNativeDisplayShareAudioSelection(environment: DisplayShareEnvironment): boolean {
	return environment !== 'desktop-custom';
}

export function prestartAudioToggleIsPickerOwned(environment: DisplayShareEnvironment): boolean {
	return environment === 'web';
}

export function canRestartDisplayShareWithoutPreselectedSource(environment: DisplayShareEnvironment): boolean {
	return environment !== 'desktop-custom';
}

export function shouldShowDesktopDownloadCta(environment: DisplayShareEnvironment): boolean {
	return environment === 'web';
}
